module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "box-header"
  }, [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "data-toggle": "modal",
      "data-target": _vm.createModalIdDisplay
    }
  }, [_vm._v("\n          Create new\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 secondary--text",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate(1)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "justify-content": "right"
    },
    attrs: {
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate(1)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "options": _vm.pagination,
      "server-items-length": _vm.totalRows
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.website))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.phoneNumber))]), _vm._v(" "), _c('td', [_c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.deleteCompany(item.id)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            staticClass: "ims-action primary ml-1",
            attrs: {
              "small": "",
              "data-toggle": "modal",
              "data-target": _vm.editModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getCompanyDataToEdit(item.id)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', {
            staticClass: "ims-action ml-1",
            attrs: {
              "small": "",
              "color": "info",
              "data-toggle": "modal",
              "data-target": _vm.viewModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getCompanyDataToView(item.id)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-eye")])], 1)], 1)])
        }), 0)]
      }
    }])
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('create-company-modal', {
    attrs: {
      "modalId": _vm.createModalId
    },
    on: {
      "createCompany": _vm.createCompany
    }
  }), _vm._v(" "), _c('edit-company-modal', {
    attrs: {
      "modalId": _vm.editModalId,
      "companyData": _vm.editCompanyData
    },
    on: {
      "editCompany": _vm.editCompany
    }
  }), _vm._v(" "), _c('view-company-modal', {
    attrs: {
      "modalId": _vm.viewModalId,
      "companyData": _vm.viewCompanyData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0782bbe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Company/index.vue
// module id = 1986
// module chunks = 0